/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 29/7/2022
 */

import {Type} from "@qwoach/class-transformer-wrapper";
import SendingReminderWrapper from "@shared/scheduler/reminders/SendingReminderWrapper";
import BaseIdObject from "@shared/BaseIdObject.js";


export default class DripContentPackageWrapper extends BaseIdObject {

	@Type(() => SendingReminderWrapper)
	sendingReminderWrapperArray: SendingReminderWrapper[] = []

	constructor() {
		super();
	}

}
